import Repository from "./Repository";
import TokenService from "../helpers/token";
const resource = `${Repository.defaults.baseURL}`
const config = {
    headers: TokenService.getHeader()
};
export default {
    async getsubjectId() {
        const response = await Repository.get(`${resource}/subject/can-interview`,config)
        return response
    },
    async getListTest(id,params) {
        if(params) {
            const response = await Repository.get(`${resource}/interview-calendars/${id}/all`,{params,...config});
            return response
        }else {
            const response = await Repository.get(`${resource}/interview-calendars/${id}/all`,config);
            return response
        }

    },

    async createSlotTest(params) {
        const response = await Repository.post(`${resource}/interview-cases`, params, config)
        return response
    },

    async updateSlotTest(id, params) {
        const response = await Repository.put(`${resource}/interview-cases/${id}`, params, config)
        return response
    },

    async deleteSlotTest(id) {
        const response = await Repository.delete(`${resource}/interview-cases/${id}`, config)
        return response
    },

    async getInterviewCaseType() {
        const response = await Repository.get(`${resource}/interview-case-type`, config)
        return response
    },

    async getInterviewStatuses() {
        const response = await Repository.get(`${resource}/interview-calendars/statuses`, config)
        return response
    },
    // slot trong ca test

    async getInfoSlot(id) {
        const response = await Repository.get(`${resource}/interview-calendars/${id}`, config)
        return response
    },

    async addSlotTest(params) {
        const response = await Repository.post(`${resource}/interview-calendars/add-slot`,params, config)
        return response
    },

    async updateSlotTestItem(id,params){
        const response = await Repository.post(`${resource}/interview-calendars/${id}/add-more-slot`,params, config)
        return response
    },

    // overview vận hành
    async getListComfirm(params) {
        let response = await Repository.get(
            `${resource}/tutor-test/v2?`, {
                params,
                headers: TokenService.getHeader(),
            }
        );
        return response;
    },
    async getInterviewsDetail(contactId){
        let response =  await Repository.get(`${resource}/tutor-test/v3/contact/${contactId}/interviews`,{
            headers:TokenService.getHeader()
        })
        return response
    },
    async createNote(contactId,body){
        let response =  await Repository.post(`${resource}/tutor-test/v2/${contactId}/history`,body,{
            headers:TokenService.getHeader()
        })
        return response
    },
    async deleteContactHistory(contactId) {
        const response = await Repository.delete(`${resource}/tutor-test/v2/${contactId}/history`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async updateNote(contactId,body){
        let response =  await Repository.put(`${resource}/tutor-test/v2/${contactId}/history`,body,{
            headers:TokenService.getHeader()
        })
        return response
    },
    async getNote(contactId,params){
        let response =  await Repository.get(`${resource}/tutor-test/v2/${contactId}/history`,{
            params,
            headers:TokenService.getHeader()
        })
        return response
    },
    async confirmTest(tutorPracticeId){
        let response =  await Repository.put(`${resource}/tutor-test/v2/practice/${tutorPracticeId}/test/confirm`,{
            headers:TokenService.getHeader()
        })
        return response
    },
    async cancelTest(tutorPracticeId){
        let response =  await Repository.put(`${resource}/tutor-test/v2/practice/${tutorPracticeId}/test/cancel`,{
            headers:TokenService.getHeader()
        })
        return response
    },
    async confirmInterview(tutorPracticeId){
        let response =  await Repository.put(`${resource}/tutor-test/v2/practice/${tutorPracticeId}/interview/confirm`,{
            headers:TokenService.getHeader()
        })
        return response
    },
    async updatePractice(id,params){
        let response =  await Repository.put(`${resource}/tutor-test/v2/practice/${id}`,params,{
            headers:TokenService.getHeader()
        })
        return response
    },
    async cancelInterview(tutorPracticeId){
        let response =  await Repository.put(`${resource}/tutor-test/v2/practice/${tutorPracticeId}/interview/cancel`,{
            headers:TokenService.getHeader()
        })
        return response
    },
    async getSubject() {
        const response = await Repository.get(`${resource}/subject/can-interview`,{
            headers:TokenService.getHeader()
        })
        return response
    },
    async getMath() {
        const response = await Repository.get(`${resource}/tutor-test/grade`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getListObject() {
        const response = await Repository.get(`${resource}/tutor-test/subject`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    // async getsubjectId() {
    //     const response = await Repository.get(`${resource}/subject/can-interview`,{
    //         headers:TokenService.getHeader()
    //     })
    //     return response
    // },
    async CreateLinkTest(contactTutor) {
        const response = await Repository.post(`${resource}/tutor-test/v2/test`, contactTutor, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async CreateStation(payload) {
        return await Repository.post(`${resource}/tutor-test/v2/test/station`, payload);
    },

    async getListTester(params) {
        let response = await Repository.get(
            `${resource}/tutor-test/v2/list-tester`, {
                params,
                headers: TokenService.getHeader()
            }
        );
        return response;
    },
    async getListOperator(params) {
        let response = await Repository.get(
            `${resource}/tutor-test/v2/list-operator`, {
                params,
                headers: TokenService.getHeader()
            }
        );
        return response;
    },
    async getListStatus(params) {
        let response = await Repository.get(
            `${resource}/tutor-test/v2/status`, {
                params,
                headers: TokenService.getHeader()
            }
        );
        return response;
    },
    async updateContactStatusTest(body) {
        const response = await Repository.post(`${resource}/tutor-test/v2/test/change-status`, body,
            {headers: TokenService.getHeader()}
        );
        return response
    },

    async updateContactStatusOperator(body) {
        const response = await Repository.post(`${resource}/tutor-test/v2/operator/change-status`, body,
            {headers: TokenService.getHeader()}
        );
        return response
    },
    async updateContactTesterTest(body) {
        const response = await Repository.post(`${resource}/tutor-test/v2/test/assign`, body,
            {headers: TokenService.getHeader()}
        );
        return response
    },

    async updateContactTesterOperator(body) {
        const response = await Repository.post(`${resource}/tutor-test/v2/operator/assign`, body,
            {headers: TokenService.getHeader()}
        );
        return response
    },

    async getContactInterviews(contactId, subjectId, params) {
        let response = await Repository.get(
            `${resource}/contact/${contactId}/${subjectId}/interviews`, {
                headers: TokenService.getHeader(),
                params,
            }
        );
        return response;
    },

    async getSubjectInterview() {
        let response = await Repository.get(
            `${resource}/subject/can-interview`, {
                headers: TokenService.getHeader()
            }
        );
        return response;
    },

    async createContactInterviews(params) {
        let response = await Repository.post(
            `${resource}/tutor-test/v2/interview`,params, {
                headers: TokenService.getHeader()
            }
        );
        return response;
    },

    async getListTeacherTypes() {
        const response = await Repository.get(`${resource}/tutor-test/v2/list-teacher-type`, {
            headers: TokenService.getHeader()
        });
        return response;
    },

    async getListTeacherTypesV3() {
        const response = await Repository.get(`${resource}/tutor-test/v3/list-teacher-type`, {
            headers: TokenService.getHeader()
        });
        return response;
    },

    // Danh sách "chương trình"
    async getListCurriculum(param) {
        const TIENG_ANH = 3;
        const params = {
            ...param,
            subject_id: param?.subject_id || TIENG_ANH,
        };
        let response = await Repository.get(
            `${resource}/tutor-program-curriculum`, {
                params,
                headers: TokenService.getHeader()
            }
        );
        return response;
    },

    // Danh sách "ca test"
    async getListCaseTypes() {
      const response = await Repository.get(`${resource}/interview-cases/case-type/list`, {
        headers: TokenService.getHeader()
      });
      return response;
    },

    async fgApi(params) {
        return await Repository.get(`${Repository.defaults.baseURL}/fg/list`, {params});
    },
    async fgApiSet(payload) {
        return await Repository.post(`${Repository.defaults.baseURL}/fg/set`, payload);
    },
    async createTrial(payload) {
        return await Repository.post(`${Repository.defaults.baseURL}/trial`, payload);
    },
    async deleteTicketTrial(id) {
        let response =  await Repository.delete(`${resource}/ieltsy-trial/${id}`,{
            headers:TokenService.getHeader()
        })
        return response
    },
    async redoTest(params) {
      let response = await Repository.post(`${resource}/tutor-test/try-test`, params, {
          headers: TokenService.getHeader()
      })
        return response;
    }
}
